<div class="logged-out" *ngIf="ready">
  <h1>Sesión cerrada</h1>
  <p>Has cerrado sesión correctamente. Inicia sesión de nuevo para continuar.</p>
  <p *ngIf="loginError" class="p-error" role="alert">{{ loginError }}</p>
  <button type="button" class="p-button p-component" (click)="login(); $event.stopPropagation()">
    Iniciar sesión
  </button>
</div>
